import { FunctionComponent } from 'preact';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getTitleId } from '../../htmlElements/htmlElementsIdGetter';
import { getTitleStyleObject } from './title.style';
import { DISCOVERY_UP_NEXT_TITLE } from '../../discoveryPlugin.constants';
import { isEmpty } from '../../../../common/utils/utils';
import { css } from '../../../../common/styles/styles.utils';

interface TitleProps {
  playerUniqueId: string;
  nextVideoTitle?: string;
  smallNextVideo?: boolean;
}

export const Title: FunctionComponent<TitleProps> = props => {
  const {
    playerUniqueId,
    nextVideoTitle,
    smallNextVideo,
  } = props;

  const showTitle = !isEmpty(nextVideoTitle);

  const styles = useStyles(getTitleStyleObject, [smallNextVideo]);
  const { titleWrapperStyle, titleStyle, upNextTitleStyle } = styles;

  return (
    <div id={getTitleId(playerUniqueId)} style={css(titleWrapperStyle)}>
      <span style={upNextTitleStyle}>
        {showTitle ? `${DISCOVERY_UP_NEXT_TITLE}: ` : DISCOVERY_UP_NEXT_TITLE}
      </span>
      {showTitle ?
        (
          <span style={titleStyle}>
            {nextVideoTitle}
          </span>
        ) :
        null}
    </div>
  );
};
